import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setPlayerSession, getPlayerSession } from '../session';

export function Join() {
  const [code, setCode] = useState('');
  const [nickname, setNickname] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    const n = nickname.trim();
    if (!c || !n) return;
    // Keep the existing playerId if re-joining the same game (avoids a duplicate);
    // a different code starts fresh.
    const prev = getPlayerSession();
    const playerId = prev && prev.code === c ? prev.playerId : undefined;
    setPlayerSession({ code: c, nickname: n, playerId });
    navigate(`/play/${c}`);
  };

  return (
    <div className="card centered">
      <h1>Join the quiz</h1>
      <p className="muted">Enter the game code from the host and pick a nickname.</p>
      <form onSubmit={submit} className="stack">
        <label>
          Game code
          <input
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="e.g. K7QP"
            maxLength={8}
            autoCapitalize="characters"
            autoCorrect="off"
          />
        </label>
        <label>
          Nickname
          <input
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="Your name"
            maxLength={24}
          />
        </label>
        <button type="submit" className="primary" disabled={!code.trim() || !nickname.trim()}>
          Join game
        </button>
      </form>
    </div>
  );
}
